import * as swcHelpers from '@swc/helpers';
import React__default, { useMemo } from 'react';
import classnames from 'classnames';
import ButtonLoader from '../ButtonLoader/ButtonLoader.js';

const Button = (_param)=>{
    var { children , className , type ='button' , variant , size , loading , loadingLabel  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "type",
        "variant",
        "size",
        "loading",
        "loadingLabel"
    ]);
    const classes = useMemo(()=>classnames('btn', `btn--${variant}`, {
            [`btn--${size}`]: variant !== 'ghost' && size && size !== 'medium'
        }, className)
    , [
        className,
        variant,
        size
    ]);
    const a11y = useMemo(()=>{
        if (!loading) {
            return {};
        }
        return swcHelpers.objectSpread({
            role: 'status',
            'aria-live': 'polite'
        }, loadingLabel && {
            'aria-label': loadingLabel
        });
    }, [
        loading,
        loadingLabel
    ]);
    return /*#__PURE__*/ React__default.createElement("button", swcHelpers.extends({
        type: type,
        className: classes
    }, props, a11y), loading && /*#__PURE__*/ React__default.createElement(ButtonLoader, null), /*#__PURE__*/ React__default.createElement("span", null, children));
};
var Button$1 = Button;

export { Button$1 as default };
//# sourceMappingURL=Button.js.map
